export default "__VITE_ASSET__1ef2ebf2__"